import { useMemo, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import { useDispatch } from "react-redux";
import { getGeocode, LatLng } from 'use-places-autocomplete';
import { setMapLocation } from "@src/core/controllers";


export const useChangeCoords = () => {
  const dispatch = useDispatch();

  const onChangeCoordsFn = useCallback(async (coords: LatLng) => {
    const { lat, lng } = coords;

    if (isNaN(lat) || isNaN(lng)) return;

    const payload = { location: { lat, lng } };
    const addresses = await getGeocode(payload);

    if (addresses.length < 1) return;

    const [{ formatted_address }] = addresses;

    dispatch(
      setMapLocation({
        latitude: lat,
        longitude: lng,
        address: formatted_address,
      })
    );
  }, [dispatch]);

  const onChangeCoords = useMemo(() => debounce(onChangeCoordsFn, 500), [onChangeCoordsFn]);

  useEffect(() => {
    return () => onChangeCoords.cancel();
  }, [onChangeCoords]);

  return onChangeCoords;
};
